import axios from 'axios'
import { URL } from '../../../../config'

export const postAthletes = function (updates,token) 
{
  const athleteEndpoint = `/athletes/update`
  const  athleteURL =  `${URL.postevent}${athleteEndpoint}` 
   console.log('posting athletes',updates )
  return axios.post(athleteURL,updates,
	{ 
    crossdomain: true,
    headers: {
      'Access-Control-Allow-Origin' : '*',
      'Access-Control-Allow-Methods' : 'GET,PUT,POST,DELETE,PATCH,OPTIONS',
      'Authorization' : `Bearer ${token}` 
    }
	})
}


// WEBPACK FOOTER //
// ./src/components/pages/Athlete/api/postAthletes.js